/**
 * @name: omlines
 * @description: 客服相关接口
 * @author: qq2575896094
 * @time: 2024/5/6
 */

const prefix = '/onlinecs'

/**
 * 客服基础配置
 * @type {string}
 */
export const getRobotBasicConfigUrl = `${prefix}/config/getRobotBasicConfig`

/**
 * 客服配置修改
 * @type {string}
 */
export const modifyConfigUrl = `${prefix}/config/modifyConfig`

/**
 * 会话监控接待数据
 * @type {string}
 */
export const getCsReceptionSessionOverviewDataUrl = `${prefix}/sessionController/getCsReceptionOverviewData`

/**
 * 未响应人次列表
 * @type {string}
 */
export const getQueryUnReactedRoundPageUrl = `${prefix}/sessionController/queryUnReactedRoundPage`

/**
 * 会话监控列表
 * @type {string}
 */
export const sessionPageUrl = `${prefix}/sessionController/sessionPage`

/**
 * 结束会话
 * @type {string}
 */
export const getFinishSessionUrl = `${prefix}/sessionController/finishSession`

/**
 * 技能组列表
 * @type {string}
 */
export const getShopGroupListUrl = `${prefix}/sys/shop/group/list`

/**
 * 员工列表
 * @type {string}
 */
export const getEmployeeListUrl = `${prefix}/sys/employee/working`

/**
 * 转接
 * @type {string}
 */
export const getTransferSessionUrl = `${prefix}/sessionController/transferSession`

/**
 * 留言
 * @type {string}
 */
export const callBackUrl = `${prefix}/sessionController/callBack`

/**
 * 批量转接
 * @type {string}
 */
export const getBatchTransferSessionUrl = `${prefix}/sessionController/batchTransferSession`

/**
 * 商铺列表
 * @type {string}
 */
export const getShopListUrl = `${prefix}/sys/shop`

/**
 * 删除店铺
 * @type {string}
 */
export const getShopDeleteUrl = `${prefix}/sys/shop/delete`

/**
 * 创建店铺
 * @type {string}
 */
export const getShopCreateUrl = `${prefix}/sys/shop/create`

/**
 * 更新店铺
 * @type {string}
 */
export const getShopUpdateUrl = `${prefix}/sys/shop/update`

/**
 * 查询分组
 * @type {string}
 */
export const getQueryShopGroupUrl = `${prefix}/sys/shop/group/query`

/**
 * 创建分组
 * @type {string}
 */
export const getCreateShopGroupUrl = `${prefix}/sys/shop/group/create`

/**
 * 更新分组
 * @type {string}
 */
export const getGroupUpdateUrl = `${prefix}/sys/shop/group/update`

/**
 * 删除分组
 * @type {string}
 */
export const getDeleteShopGroupUrl = `${prefix}/sys/shop/group/delete`

/**
 * 获取用户工作状态
 * @type {string}
 */
export const getCustomerServiceStatusUrl = `${prefix}/customer/getCustomerServiceStatus`

/**
 * 获取店铺所有组
 * @type {string}
 */
export const getShopAllGroupUrl = `${prefix}/sys/shop/allGroup`

/**
 * 用户列表
 * @type {string}
 */
export const getEmployeeQueryListUrl = `${prefix}/sys/employee/query`

/**
 * 店铺下的客服人员
 * @type {string}
 */
export const workOrderUrl = `${prefix}/sys/employee/workOrder`

/**
 * 创建用户
 * @type {string}
 */
export const getEmployeeRegisterUrl = `${prefix}/sys/employee/register`

/**
 * 更新用户
 * @type {string}
 */
export const getEmployeeUpdateUrl = `${prefix}/sys/employee/update`

/**
 * 删除用户
 * @type {string}
 */
export const getEmployeeDeleteUrl = `${prefix}/sys/employee/delete`

/**
 * 获取系统角色列表
 * @type {string}
 */
export const getRoleListUrl = `${prefix}/sys/role`

/**
 * 更新角色权限
 * @type {string}
 */
export const getRoleUpdateUrl = `${prefix}/sys/role/update`

/**
 * 离线消息数据统计
 * @type {string}
 */
export const queryOfflineDataUrl = `${prefix}/imMessageController/queryOfflineData`

/**
 * 离线消息池
 * @type {string}
 */
export const queryOfflineMessagePageUrl = `${prefix}/imMessageController/queryOfflineMessagePage`

/**
 * 搜索人维度的聊天记录列表
 * @type {string}
 */
export const queryChatRecordList = `${prefix}/imMessageController/queryChatRecordList`

/**
 * 人维度的聊天记录
 * @type {string}
 */
export const queryChatRecordByUid = `${prefix}/imMessageController/queryChatRecordByUid`

/**
 * 下载聊天记录
 * @type {string}
 */
export const downloadChatRecordList = `${prefix}/imMessageController/downloadChatRecordList`

/**
 * 获取所有客服
 * @type {string}
 */
export const getAllEmployeeListUrl = `${prefix}/sys/employee/all`

/**
 * 获取组内客服
 * @type {string}
 */
export const getEmployeeByGroupUrl = `${prefix}/sys/group/employee`

/**
 * 会话历史
 * @type {string}
 */
export const queryChatRecordBySessionUrl = `${prefix}/imMessageController/queryChatRecordBySession`

/**
 * 接待数据
 * @type {string}
 */
export const getCsReceptionOverviewDataUrl = `${prefix}/getCsReceptionOverviewData`

/**
 * 客服评价
 * @type {string}
 */
export const querySessionEvaluateListUrl = `${prefix}/sessionController/querySessionEvaluateList`

/**
 * 获取客服评价对话
 * @type {string}
 */
export const queryChatRecordListByEvaluationUrl = `${prefix}/sessionController/queryChatRecordListByEvaluation`

/**
 * 销售数据
 * @type {string}
 */
export const getCsSaleOverviewDataUrl = `${prefix}/getCsSaleOverviewData`

/**
 * 查看接待数据详情
 * @type {string}
 */
export const getCsReceptionDetailUrl = `${prefix}/getCsReceptionDetail`

/**
 * 销售总览下载
 * @type {string}
 */
export const downloadCsSaleOverviewData = `${prefix}/sessionController/downloadCsSaleOverviewData`

/**
 * 接待总览下载
 * @type {string}
 */
export const downloadCsReceptionOverviewData = `${prefix}/sessionController/downloadCsReceptionOverviewData`

/**
 * 客服总览下载
 * @type {string}
 */
export const downloadCsReceptionDetail = `${prefix}/sessionController/downloadCsReceptionDetail`

/**
 * 客服接待详情下载
 * @type {string}
 */
export const downloadCsReceptionDetailUrl = `${prefix}/sessionController/downloadSessionPage`

/**
 * 客服评价下载
 * @type {string}
 */
export const downloadSessionEvaluateListUrl = `${prefix}/sessionController/downloadSessionEvaluateList`

/**
 * 查询是否展示自动接待开关
 * @type {string}
 */
export const queryAutoRobotRoleUrl = `${prefix}/threadSessionController/queryAutoRobotRole`
